import React,{useEffect,useState} from 'react'
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import AddArticleCard from '../Admin/Consumer/AddArticleCard';
import { ArticleGet } from '../../api/orgService';
import useApi from '../../api/useApi';

function NewsInternalForm({handleSubmit,handleChange,form,okayToSubmit}) {

   const { request: getRelatedArticles, data:relatedArticlesData, error:relatedArticlesError,isLoading:getRelatedArticlesLoading} = useApi(ArticleGet);
            
     const [relatedArticles,setRelatedArticles] = useState([])
      useEffect(() => {
    
        getRelatedArticles();
        
              // eslint-disable-next-line
        }, []);

        useEffect(()=>{},[form])
          
    useEffect(()=>{
      if (relatedArticlesData?.status===200) {
        setRelatedArticles(relatedArticlesData?.data?.results);
      }
    // eslint-disable-next-line
    },[relatedArticlesData])

    const makeEvent = (name, value) => ({
      target: {
        name,
        value
      }
    });

    const handleSelectArticle = (article)=>{
      console.log(article)

      // const e1 = makeEvent("title", article?.title);
      // const e2 = makeEvent("link", `article/${article?.title.slice(0,20)}/${article?.id}/`);
      // const e3 = makeEvent("image", article?.img);
      // let e = {target:{name:{
      //   title:{value:article?.title},
      //   link:{value:`article/${article?.title.slice(0,20)}/${article?.id}/`},
      //   image:{value:article?.img}},
      // }}

      // handleChange(e)
      handleChange({ target: { name: "title", value: article?.title } });
      handleChange({ target: { name: "link", value: `article/.../${article?.id}/` } });
      handleChange({ target: { name: "image", value: article?.img } });
      handleChange({ target: { name: "subtitle", value: article?.description } });
    }

  return (
    <div>
        <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
            <i>Required fields are marked with an asterisk (*).</i>

            <AddArticleCard message="Select related article" articles={relatedArticles} onSelectArticle={handleSelectArticle}/>
  
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={form?.title}
                onChange={handleChange}
                margin="normal"
                required
                disabled
                
              />
  
              
              <Typography variant='p' component="p" color='#404040'>
              Write a brief summary statement or description that explains about the main point point of the article.
              </Typography>
             
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={form?.description}
                onChange={handleChange}
                margin="normal"
                required
              />
  
              {/* <SubCategorySelect setCategoryId={handleChangeCategory } setSubCategoryId={handleChangeSubCategory } /> */}
              {/* <TextField
                fullWidth
                label="Organisation tag Name"
                name="org_tag"
                value={form.subcategory}
                onChange={handleChange}
                margin="normal"
                required
              /> */}
  
              {/* <TextField
                fullWidth
                label="Organisation tag Name"
                name="org_tag"
                value={form.category}
                onChange={handleChange}
                margin="normal"
                required
              /> */}
              
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 1 ,mb:5}}
                // disabled={okayToSubmit}
              >
                Create Article
              </Button>
            </form>
    </div>
  )
}

export default NewsInternalForm